export const GET_MEETING_DETAILS = "GET@MEETING_DETAILS";
export const GET_MEETING_DETAILS_INIT = "GET@MEETING_DETAILS_INIT";
export const GET_MEETING_DETAILS_SUCCESS = "GET@MEETING_DETAILS_SUCCESS";
export const GET_MEETING_DETAILS_FAILED = "GET@MEETING_DETAILS_FAILED";

export const UPDATE_STATUS_ATTENDEE = "DELETE@UPDATE_STATUS_ATTENDEE";
export const UPDATE_STATUS_ATTENDEE_INIT = "DELETE@UPDATE_STATUS_ATTENDEE_INIT";
export const UPDATE_STATUS_ATTENDEE_SUCCESS = "DELETE@UPDATE_STATUS_ATTENDEE_SUCCESS";
export const UPDATE_STATUS_ATTENDEE_FAILED = "DELETE@UPDATE_STATUS_ATTENDEE_FAILED";

export const UPDATE_GOOGLE_CALENDAR_MEETING = "MEETING@UPDATE_GOOGLE_CALENDAR_MEETING";
export const UPDATE_GOOGLE_CALENDAR_MEETING_INIT = "MEETING@UPDATE_GOOGLE_CALENDAR_MEETING_INIT";
export const UPDATE_GOOGLE_CALENDAR_MEETING_SUCCESS = "MEETING@UPDATE_GOOGLE_CALENDAR_MEETING_SUCCESS";
export const UPDATE_GOOGLE_CALENDAR_MEETING_FAILED = "MEETING@UPDATE_GOOGLE_CALENDAR_MEETING_FAILED";

export const UPDATE_OUTLOOK_CALENDAR_MEETING = "MEETING@UPDATE_OUTLOOK_CALENDAR_MEETING";
export const UPDATE_OUTLOOK_CALENDAR_MEETING_INIT = "MEETING@UPDATE_OUTLOOK_CALENDAR_MEETING_INIT";
export const UPDATE_OUTLOOK_CALENDAR_MEETING_SUCCESS = "MEETING@UPDATE_OUTLOOK_CALENDAR_MEETING_SUCCESS";
export const UPDATE_OUTLOOK_CALENDAR_MEETING_FAILED = "MEETING@UPDATE_OUTLOOK_CALENDAR_MEETING_FAILED";

export const GET_MONTHLY_MEETING = "GET@MONTHLY_MEETING";
export const GET_MONTHLY_MEETING_INIT = "GET@MONTHLY_MEETING_INIT";
export const GET_MONTHLY_MEETING_SUCCESS = "GET@MONTHLY_MEETING_SUCCESS";
export const GET_MONTHLY_MEETING_FAILED = "GET@MONTHLY_MEETING_FAILED";